export const FETCH_OUTLET='Fetch outlet'
export const UPDATE_OUTLET='Update Outlet'
// export const UPDATE_ORDER='Update order'
